import { jsxs as t, jsx as a } from "react/jsx-runtime";
import c from "clsx";
import '../../_assets/Icon.qieQIMeg.css';const d = "_icon_8sy5x_1", m = {
  icon: d
}, f = ({
  titleAccess: o,
  htmlColor: n,
  children: i,
  className: r,
  dataTestId: s,
  ...l
}) => /* @__PURE__ */ t(
  "svg",
  {
    ...l,
    className: c(r, m.icon),
    focusable: !1,
    "aria-hidden": o ? void 0 : "true",
    role: o ? "img" : void 0,
    color: n,
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": s,
    children: [
      o ? /* @__PURE__ */ a("title", { children: o }) : null,
      i
    ]
  }
);
export {
  f as Icon
};
